import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import ProjectMoyer from '../components/Projects/ProjectMoyer'

const Projectpage = () => {
    return (
        <div>
        <Navbar/>

        <ProjectMoyer/>


        <Footer/>


        </div>
    )
}

export default Projectpage
